import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";

// Element UI
import elementUi from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(elementUi);

// iconfont
import "@/assets/iconfont/iconfont.css";

// 路由拦截
import "@/permission";

// table表格悬浮滚动条
import horizontalScroll from "@/utils/directive.js";
Vue.use(horizontalScroll);

// 指令式的防抖，使用v-debounce="1500"声明一个1500毫秒间隔的防抖
Vue.directive("debounce", {
  bind: (el, binding) => {
    const throttleTime = binding.value;
    let timer: any;
    let disable = false;
    el.addEventListener(
      "click",
      (event) => {
        if (timer) {
          clearTimeout(timer);
        }
        if (!disable) {
          // 马上执行
          disable = true;
        } else {
          event && event.stopImmediatePropagation();
        }
        timer = setTimeout(() => {
          timer = null;
          disable = false;
        }, throttleTime);
      },
      true
    );
  },
});

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
